module.exports = __webpack_public_path__ + "img/1016_pc.45ebc063.gif";